import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ClaimsRoutingModule } from './claims-routing.module';
import { ClaimsComponent } from './claims.component';
import { EnvironmentModule } from '@shared/modules/environment/environment.module';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    declarations: [
        ClaimsComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        EnvironmentModule,
        ClaimsRoutingModule,
    ],
    bootstrap: [ClaimsComponent]
})
export class ClaimsModule { }